import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavigateButton } from './NavigateButton';

type SearchParam = {
  name: string;
  value: string;
};

type Props = {
  disabled?: boolean;
  searchParams?: SearchParam[];
};

export const NavigateEditPageButton: FC<Props> = ({
  disabled,
  searchParams,
}) => {
  const { t } = useTranslation();
  const urlSearchParams =
    searchParams &&
    new URLSearchParams(searchParams.map(({ name, value }) => [name, value]));
  return (
    <NavigateButton
      path={`edit?${urlSearchParams?.toString() ?? ''}`}
      text={t('edit')}
      disabled={disabled}
    />
  );
};
